import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="privacy">
      <Header />
      <main className="content">
        <div className="hero hero--large" data-testid="hero">
          <div className="hero-media" data-testid="hero-media">
            <picture className="image-wrapper  ">
              <img
                className="image-wrapper__img "
                src="/main/p1.jpg"
                alt="Woman holding a smartphone displaying the Rivergrove App, monitorartoria her home security feed in a well-lit room."
                data-testid="hero-media-img"
              />
            </picture>
          </div>
          <div className="hero-copy  ">
            <h1 className="h2" data-delay="0.25" data-testid="hero-headline">
              Your privacy
              <br />
              is our priority.
            </h1>
          </div>
        </div>
        <div className="spacer spacer--extra-large " data-testid="spacer[0]" />
        <section
          className="grid-wrapper center-aligned-message  


spacing--default "
          data-testid="center-aligned-message"
        >
          <div
            className="center-aligned-message__container"
            data-testid="center-aligned-block"
          >
            <p
              className="center-aligned-message__body-copy"
              data-testid="center-aligned-body"
            >
              Respect for customer privacy and security guides every action we
              take at Rivergrove. From giving customers easy-to-use products and
              services that help them protect and connect to the places, people
              and things that matter to them to prioritizing the privacy,
              security and control of their devices and personal information,
              our commitment to privacy is built on the following guiding
              pillars.
            </p>
          </div>
        </section>
        <div className="spacer spacer--extra-large " data-testid="spacer[1]" />

        <section
          className="slider-wrapper 


spacing--default"
          data-testid="slider-wrapper[0]"
        >
          <section
            className="multiple-media-wrapper padding--standard multiple-media-wrapper--tertiary-300"
            data-testid="multiple-media-wrapper"
          >
            <h2 className="multiple-media-wrapper__title">
              Our Privacy Pillars
            </h2>
            <div className="ios-padding-helper">
              <div
                className="card-slider__container card-slider__container--active multiple-media-wrapper__container card-slider__container--center"
                role="region"
                aria-label="Rivergrove app notification images slider"
                tabIndex={0}
              >
                <div
                  className="slider-wrapper__card multiple-media-wrapper__card active"
                  data-cur={0}
                >
                  <div
                    className="multiple-media-wrapper__image"
                    data-testid="multi-media-img"
                  >
                    <picture className="image-wrapper  ">
                      <img
                        className="image-wrapper__img "
                        alt="blueprint padlock design, with screwdriver and ruler, symbolizing privacy and security."
                        src="/main/p2-1.png"
                      />
                    </picture>
                  </div>
                  <div
                    className="multiple-media-wrapper__text"
                    data-testid="multi-media-text"
                  >
                    <h4 className="h1">Privacy and security built in.</h4>
                    <p>
                      From the initial idea to the final product, privacy and
                      security are at the core of the decisions we make at
                      Rivergrove.
                    </p>
                  </div>
                </div>
                <div
                  className="slider-wrapper__card multiple-media-wrapper__card "
                  data-cur={1}
                >
                  <div
                    className="multiple-media-wrapper__image"
                    data-testid="multi-media-img"
                  >
                    <picture className="image-wrapper  ">
                      <img
                        className="image-wrapper__img "
                        alt="hand holding smartphone displaying a checkmark, symbolizing customer control over Rivergrove privacy and security settings."
                        src="/main/p2-2.png"
                      />
                    </picture>
                  </div>
                  <div
                    className="multiple-media-wrapper__text"
                    data-testid="multi-media-text"
                  >
                    <h4 className="h1">Customers have control.</h4>
                    <p>
                      Rivergrove provides customers control over who’s able to
                      see and access their videos, devices and personal
                      information.
                    </p>
                  </div>
                </div>
                <div
                  className="slider-wrapper__card multiple-media-wrapper__card "
                  data-cur={2}
                >
                  <div
                    className="multiple-media-wrapper__image"
                    data-testid="multi-media-img"
                  >
                    <picture className="image-wrapper  ">
                      <img
                        className="image-wrapper__img "
                        alt="Person standing in an open doorway waving next to a dog."
                        src="/main/p2-3.png"
                      />
                    </picture>
                  </div>
                  <div
                    className="multiple-media-wrapper__text"
                    data-testid="multi-media-text"
                  >
                    <h4 className="h1">Commitment to transparency.</h4>
                    <p>
                      We’re committed to being transparent about our privacy and
                      security practices.
                    </p>
                  </div>
                </div>
              </div>
              <div className="dots">
                <div className="active  dot-item" data-cur={0} tabIndex={0} />
                <div className=" dot-item" data-cur={1} tabIndex={0} />
                <div className=" dot-item" data-cur={2} tabIndex={0} />
              </div>
            </div>
          </section>
        </section>

        <section
          className="split-content 


margin--standard padding--none  "
          data-testid="split-content[0]"
        >
          <div className="grid-wrapper">
            <div className="split-content__grid split-content__grid--copy-top split-content__grid--copy-left grid-container--no ">
              <div className="split-content__content1 split-content__content1--top">
                <div
                  className="split-content__headlines"
                  data-testid="split-content-headline"
                >
                  <div className="ring-protect__logo">
                    <span className="" data-testid="svg-icon[0]"></span>
                    <h3 className="h1">Video Security</h3>
                  </div>
                  <h2 className="ring-protect__title">
                    Keeping your videos safe
                  </h2>
                </div>
                <div
                  className="ring-protect__accordion"
                  data-testid="accordion"
                >
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Default video encryption
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      Rivergrove encrypts your videos stored in the cloud at
                      rest and in transit by default. To learn more, see the
                      Video Encryption page in Control Center.
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Optional Video End-to-End Encryption
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      This additional advanced encryption option gives you even
                      more control over who can view your videos. .
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Secure video storage
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      With a Rivergrove Protect Plan, your Rivergrove videos in
                      the cloud are stored temporarily, up to 180 days
                      (depending on your storage time setting). .
                    </p>
                  </div>
                </div>
              </div>
              <div className="split-content__content2">
                <div
                  className="image-wrapper__video image-wrapper__video-overlay--visible  "
                  data-pause-at-beginning="true"
                  data-replay-button="false"
                  data-testid="split-content-img"
                >
                  <div className="image-wrapper__video-container ">
                    <video
                      loop
                      muted
                      autoPlay
                      className="image-wrapper__hover-video"
                    >
                      <source src="/main/p3.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="" />
                  <div className="image-wrapper__video-replay-overlay " />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="split-content 


margin--standard padding--none  "
          data-testid="split-content[1]"
        >
          <div className="grid-wrapper">
            <div className="split-content__grid split-content__grid--copy-bottom split-content__grid--copy-right grid-container--no ">
              <div className="split-content__content1 split-content__content1--bottom">
                <div
                  className="split-content__headlines"
                  data-testid="split-content-headline"
                >
                  <div className="ring-protect__logo">
                    <span className="" data-testid="svg-icon[1]"></span>
                    <h3 className="h1">Account Security</h3>
                  </div>
                  <h2 className="ring-protect__title">
                    Keeping your account secure
                  </h2>
                </div>
                <div
                  className="ring-protect__accordion"
                  data-testid="accordion"
                >
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Two-Step Verification
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      This mandatory second layer of verification helps prevent
                      unauthorized access to your Rivergrove account. .
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Shared users
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      You choose who to share your Rivergrove account with, and
                      have control over which devices they can access. You can
                      remove any shared user at any time. .
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Extra layers of protection
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      You will receive an email notification any time a new
                      device logs into your Rivergrove account. .
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Active account protection
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      We take steps to monitor and block any identified
                      potentially unauthorized login attempts into your
                      Rivergrove account.
                    </p>
                  </div>
                </div>
              </div>
              <div className="split-content__content2">
                <div
                  className="image-wrapper__video image-wrapper__video-overlay--visible  "
                  data-pause-at-beginning="true"
                  data-replay-button="false"
                  data-testid="split-content-img"
                >
                  <div className="image-wrapper__video-container ">
                    <video
                      loop
                      muted
                      autoPlay
                      className="image-wrapper__hover-video"
                    >
                      <source src="/main/p4.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="" />
                  <div className="image-wrapper__video-replay-overlay " />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="split-content 


margin--standard padding--none  "
          data-testid="split-content[2]"
        >
          <div className="grid-wrapper">
            <div className="split-content__grid split-content__grid--copy-bottom split-content__grid--copy-left grid-container--no ">
              <div className="split-content__content1 split-content__content1--bottom">
                <div
                  className="split-content__headlines"
                  data-testid="split-content-headline"
                >
                  <div className="ring-protect__logo">
                    <span className="" data-testid="svg-icon[2]"></span>
                    <h3 className="h1">Control Center</h3>
                  </div>
                  <h2 className="ring-protect__title">You’re in control</h2>
                </div>
                <div
                  className="ring-protect__accordion"
                  data-testid="accordion"
                >
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Control from one place
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      Control Center allows you to view and control important
                      privacy and security settings from one dashboard in the
                      Rivergrove app. .
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Verify your devices
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      See all devices (phones, tablets, computers) that are
                      logged into your Rivergrove account. Click “Remove all” to
                      force devices to logout.
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Manage linked accounts
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      View and manage the services you authorized to link to
                      your Rivergrove account via Rivergrove authentication,
                      like Alexa, and IFTTT. You can remove any individual
                      service, at any time.
                    </p>
                  </div>
                  <div className="ring-protect__accordion-visible">
                    <h5
                      className="ring-protect__accordion-title"
                      data-testid="accordion-title"
                    >
                      Video request notifications
                    </h5>
                  </div>
                  <div className="ring-protect__accordion-collapsed Rivergrove-protect__accordion--text-left">
                    <p className="size-small" data-testid="accordion-copy">
                      Easily opt out of receiving{" "}
                      <Link onClick={toTop} to="/">
                        video request
                      </Link>{" "}
                      notifications at any time.
                    </p>
                  </div>
                </div>
              </div>
              <div className="split-content__content2">
                <div
                  className="image-wrapper__video image-wrapper__video-overlay--visible  "
                  data-pause-at-beginning="true"
                  data-replay-button="false"
                  data-testid="split-content-img"
                >
                  <div className="image-wrapper__video-container ">
                    <video
                      loop
                      muted
                      autoPlay
                      className="image-wrapper__hover-video"
                    >
                      <source src="/main/p5.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="" />
                  <div className="image-wrapper__video-replay-overlay " />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="slider-wrapper 


spacing--default"
          data-testid="slider-wrapper[1]"
        >
          <section
            className="testimonials 


spacing--default background__white"
            data-testid="testimonials"
          >
            <h2 className="testimonials__title">
              Keeping all your online accounts safe
            </h2>
            <div className="tabs ios-padding-helper">
              <div className="tab-container tab-container--active" data-cur={0}>
                <div
                  className="card-slider__container card-slider__container--active"
                  role="region"
                  aria-label="Rivergrove app notification images slider"
                  tabIndex={0}
                >
                  <div className="slider-wrapper__card">
                    <span className="size-small">
                      <p>
                        <strong>Create unique passwords</strong>
                      </p>
                      <p>
                        Create unique passwords for your various online
                        accounts. Do not reuse your username and passwords
                        across multiple accounts.
                      </p>
                    </span>
                  </div>
                  <div className="slider-wrapper__card">
                    <span className="size-small">
                      <p>
                        <strong>Two-Step Verification</strong>
                      </p>
                      <p>
                        Two-step verification adds an extra layer of security to
                        your accounts that offer this feature, helping prevent
                        unauthorized access, even if someone has access to your
                        account password. .
                      </p>
                    </span>
                  </div>
                  <div className="slider-wrapper__card">
                    <span className="size-small">
                      <p>
                        <strong>Add a PIN to your mobile phone account</strong>
                      </p>
                      <p>
                        Adding a PIN to your mobile account adds an extra layer
                        of security that helps prevent attackers from taking
                        over your mobile phone account. You can add a PIN from
                        the account security section of your wireless carrier’s
                        website, or by calling your carrier’s customer support.
                      </p>
                    </span>
                  </div>
                  <div className="slider-wrapper__card">
                    <span className="size-small">
                      <p>
                        <strong>Stay up-to-date</strong>
                      </p>
                      <p>
                        New features and security updates are constantly being
                        added to your devices and apps, including your
                        Rivergrove app. So make sure you stay up-to-date with
                        the latest security updates.
                      </p>
                    </span>
                  </div>
                  <div className="slider-wrapper__card">
                    <span className="size-small">
                      <p>
                        <strong>Watch out for phishing scams</strong>
                      </p>
                      <p>
                        Phishing is a common scam that targets people with
                        emails, text, or other forms of communication in an
                        attempt to gain access to personal information, such as
                        login credentials or credit card numbers. If you notice
                        a suspicious email or text that falsely claims to come
                        from Rivergrove, please{" "}
                        <Link onClick={toTop} to="/">
                          report it to us
                        </Link>
                        .
                      </p>
                    </span>
                  </div>
                  <div className="slider-wrapper__card">
                    <span className="size-small">
                      <p>
                        <strong>Use a password manager</strong>
                      </p>
                      <p>
                        Password managers help you remember different passwords
                        for multiple accounts. This helps you keep track of all
                        your unique passwords. Password managers are available
                        either as standalone apps, and are also available as
                        extensions to popular browsers like Safari or Chrome.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="dots">
                  <div className="active  dot-item" data-cur={0} tabIndex={0} />
                  <div className=" dot-item" data-cur={1} tabIndex={0} />
                  <div className=" dot-item" data-cur={2} tabIndex={0} />
                  <div className=" dot-item" data-cur={3} tabIndex={0} />
                  <div className=" dot-item" data-cur={4} tabIndex={0} />
                  <div className=" dot-item" data-cur={5} tabIndex={0} />
                </div>
                <div className="slider-navigation">
                  <div
                    className="slider-navigation__nav slider-navigation__nav--hidden slider-navigation__left fill__primary-500"
                    data-testid="slider-navigation-left"
                    role="button"
                    tabIndex={0}
                    aria-label="previous"
                  >
                    <svg
                      className="icon icon--arrow"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Arrow Icon</title>
                      <path
                        className="fill_color"
                        d="M19.2247 7.26851C19.4546 7.02876 19.7953 6.93611 20.1128 7.03176C20.4223 7.12503 20.6553 7.38064 20.7305 7.69705C20.8042 8.00684 20.7175 8.33579 20.4974 8.56534L12.6359 16.7336C12.2857 17.0971 11.7145 17.0971 11.3642 16.7336L3.50214 8.5647C3.28246 8.33565 3.19579 8.00651 3.26949 7.69653C3.34477 7.37994 3.57786 7.12419 3.88761 7.03087C4.20526 6.93517 4.54608 7.02788 4.77556 7.26715L12.0004 14.7747L19.2247 7.26851ZM12.0001 15.9342L11.9066 16.0313C11.9548 15.9813 12.0454 15.9813 12.0933 16.0311L12.0001 15.9342Z"
                        fill="#424242"
                      />
                    </svg>
                  </div>
                  <div
                    className="slider-navigation__nav slider-navigation__right fill__primary-500"
                    data-testid="slider-navigation-right"
                    role="button"
                    tabIndex={0}
                    aria-label="next"
                  >
                    <svg
                      className="icon icon--arrow"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Arrow Icon</title>
                      <path
                        className="fill_color"
                        d="M19.2247 7.26851C19.4546 7.02876 19.7953 6.93611 20.1128 7.03176C20.4223 7.12503 20.6553 7.38064 20.7305 7.69705C20.8042 8.00684 20.7175 8.33579 20.4974 8.56534L12.6359 16.7336C12.2857 17.0971 11.7145 17.0971 11.3642 16.7336L3.50214 8.5647C3.28246 8.33565 3.19579 8.00651 3.26949 7.69653C3.34477 7.37994 3.57786 7.12419 3.88761 7.03087C4.20526 6.93517 4.54608 7.02788 4.77556 7.26715L12.0004 14.7747L19.2247 7.26851ZM12.0001 15.9342L11.9066 16.0313C11.9548 15.9813 12.0454 15.9813 12.0933 16.0311L12.0001 15.9342Z"
                        fill="#424242"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>

        <div
          className="ct-faq 


margin--standard "
          id="faqs"
          data-anchor="FAQs"
          data-testid="faq"
        >
          <div data-animate="fade_up" data-delay="0.25" className="fade_up">
            <h2 tabIndex={0}>Frequently asked questions</h2>
            <div className="ct-faq_block" data-testid="faq-block">
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  When does Rivergrove record or store my videos?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  If you do not have a Rivergrove Protect Plan, Rivergrove does
                  not record or store your videos, but you can still view your
                  device's live video stream (Live View).
                  <br />
                  <br />
                </p>
                <p>
                  If you do have a Rivergrove Protect Plan (including a free
                  trial), Rivergrove records and stores videos when motion is
                  detected by your device (including motion detected via Linked
                  Devices), the video doorbell button is pressed, or you
                  initiate Live View. Stored recordings are automatically
                  deleted following the expiration of your Protect Plan’s
                  applicable storage period. For additional information
                  regarding Rivergrove’s video storage periods, see{" "}
                  <Link onClick={toTop} to="/">
                    here
                  </Link>
                  .
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  What about videos I’ve created a share link for?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  When you create a share link for one of your Rivergrove
                  videos, a copy of that video is made in the cloud to
                  facilitate sharing. You can manage your shared videos in the
                  Shared Video Management feature in Control Center in the
                  Rivergrove app and www.rivergrove.blog. There, you can unshare
                  videos, which deletes the shared copies and makes the videos
                  inaccessible to people with whom you previously shared those
                  links. The original videos in your Rivergrove account,
                  however, are not deleted until you delete them in the
                  Rivergrove app or www.rivergrove.blog or they reach the
                  expiration of your Rivergrove Protect Plan’s applicable
                  storage period.
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  How can I access and view my cloud-stored recordings?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  If you have a Rivergrove Protect Plan (including a free
                  trial), you can access your cloud-stored recordings, download
                  them, manually delete them one by one, or delete them all at
                  once in the Rivergrove app or on www.rivergrove.blog. Videos
                  stored in the cloud are automatically deleted following the
                  expiration of your Protect Plan's applicable storage period.
                  <br />
                  <br />
                  Learn how to{" "}
                  <Link onClick={toTop} to="/">
                    store videos locally with Rivergrove Edge
                  </Link>
                  .
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  How secure are my recordings?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  We have taken measures to help secure Rivergrove devices from
                  unauthorized access. These measures include restricting
                  installation of third-party applications on the device,
                  rigorous security reviews, software security development
                  requirements, and encryption of communication between
                  Rivergrove devices with services such as AWS cloud storage
                  services. Rivergrove secures video recordings in transit and
                  videos stored in the cloud on AWS servers. We use a
                  combination of AES encryption (Advanced Encryption Standard)
                  and TLS (Transport Layer Security) to secure data between
                  Rivergrove devices and AWS, and we encrypt data between
                  Rivergrove devices using AES encryption, TLS and SRTP (Secure
                  Real Time Protocol).
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  How do I share my videos?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  You’re in control of who you grant video access to. You can
                  add Shared Users to your account, who will then be able to
                  view and download video recordings on the account. You can
                  also share video recordings via text or email by creating a
                  share link to the recording. After a share link has been
                  created, the video recording may be viewed and downloaded by
                  anyone with the share link ID. Additionally, you can make your
                  videos publicly available by posting them on the Internet
                  (including by posting them to the public social media app
                  Neighbors by Rivergrove).
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Why should I add Shared Users?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  Shared Users allow you to share device access with family,
                  roommates, and others without sharartoria your login
                  credentials. Shared Users can answer and receive alerts, view
                  video recordings, and modify their personal alert settings,
                  but they cannot delete videos, delete devices, or change
                  device settings.
                  <br />
                  <br />
                  For help adding someone as a Shared User, please click{" "}
                  <Link onClick={toTop} to="/">
                    here
                  </Link>
                  .
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  If I request Rivergrove’s assistance with troubleshooting my
                  device or video recordings, will Rivergrove view my video
                  recordings?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  If you are having issues with your device or video recordings,
                  you can request assistance from Rivergrove customer support.
                  Associates do not have access to your videos and can only view
                  the video recordings that you share with them.
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Can Rivergrove employees view my videos?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  We have strong policies and controls in place that restrict
                  employee access to customers’ stored videos. Employees are not
                  able to view, access, or control live streams.
                  <br />
                  <br />
                  To help improve Rivergrove’s products, services, and
                  technology, our research and development team does view a
                  small number of video recordings. These video recordings are
                  either from users who have made them publicly available (by
                  posting them on Neighbors or otherwise on the Internet), or
                  from users, team members, and their friends and family who
                  have given us explicit permission to use them for this purpose
                  (which they may revoke at any time).
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Does Rivergrove share video recordings or other personal
                  information with law enforcement agencies?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  Rivergrove does not disclose user information in response to
                  government demands (i.e., legally valid and binding requests
                  for information from law enforcement agencies such as search
                  warrants, subpoenas and court orders) unless we're required to
                  comply and it is properly served on us. Rivergrove objects to
                  legal requests it determines to be overbroad or inappropriate.
                  Unless Rivergrove is prohibited from doing so or has clear
                  indication of illegal conduct in connection with the use of
                  Rivergrove products or services, Rivergrove notifies an
                  account owner before disclosing user information in response
                  to a valid and binding legal demand. Just like many other
                  companies, on rare occasions Rivergrove will provide
                  information to law enforcement on an emergency basis when
                  there is an imminent danger of death or serious physical
                  injury requirartoria disclosure of information without delay.
                  For additional information, see our{" "}
                  <Link onClick={toTop} to="/">
                    law enforcement guidelines
                  </Link>
                  .
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Does Rivergrove give law enforcement agencies direct access to
                  users accounts?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  No. Rivergrove does not disclose user information in response
                  to government demands (i.e., legally valid and binding
                  requests for information from law enforcement agencies such as
                  search warrants, subpoenas and court orders) unless we're
                  required to comply and it is properly served on us. Just like
                  many other companies, on rare occasions Rivergrove will
                  provide information to law enforcement on an emergency basis
                  when there is an imminent danger of death or serious physical
                  injury requiring disclosure of information without delay. For
                  additional information, see our{" "}
                  <Link onClick={toTop} to="/">
                    law enforcement guidelines
                  </Link>
                  .
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  If I use the Neighbors App, does that give Rivergrove team
                  members the right to view all of my video recordings?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  No. Rivergrove associates, similar to the general public, can
                  only view the video recordings that you have elected to make
                  publicly available by posting them on the Neighbors App (or
                  otherwise on the Internet).
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Can Rivergrove team members activate and view my live stream?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  No. Rivergrove associates cannot activate and view live
                  streams from your Rivergrove device.
                </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Does Rivergrove sell personal information to third parties?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>No. </p>
              </div>
              <div
                className="ct-faq_block__question"
                aria-level={3}
                tabIndex={0}
                data-testid="faq-dd"
              >
                <h3 className="h4" data-testid="faq-question">
                  Does Rivergrove use third-party web and app analytics cookies
                  on its website and mobile apps?
                </h3>
              </div>
              <div
                className="ct-faq_block__answer"
                role="definition"
                tabIndex={-1}
                data-testid="faq-ans"
              >
                <p>
                  We use first- and third-party web and app analytics services
                  on our websites and mobile apps. Some of these services use
                  automated technologies to collect and analyze information,
                  including personal information (such as email, device
                  identifier, and IP addresses) to understand how you use our
                  websites and mobile apps. Web and app analytics services help
                  us improve features, evaluate the effectiveness of our
                  marketing, and, ultimately, optimize the customer experience.
                  To learn more about these analytics services, please see our
                  Cookie Policy.
                </p>
                <p>
                  {" "}
                  To make a selection regarding web and app analytics cookies
                  placed by third parties and personalized advertising by third
                  parties, please visit the Control Center or Cookie Settings
                  Manager to set your preferences.
                </p>
              </div>
            </div>
            <Link onClick={toTop} className="question-link" to="/contact">
              <b>Still Have Questions?</b>
            </Link>
          </div>
        </div>
        <div
          className="grid-wrapper grid-wrapper--col-10"
          data-testid="disclaimer-text"
        >
          <span className="size-xs margin-bottom" data-testid="text">
            <p>
              <sup>1</sup>Your Rivergrove motion event videos in the cloud are
              stored, up to 180 days from recording. Modifying your video
              storage duration affects only recordings created after the change
              is applied.
              <br />
              <br />
            </p>
            <p>
              <strong>Privacy Notice</strong>
              <br />
              Take a more detailed look at our privacy notice by clicking{" "}
              <Link onClick={toTop} to="/privacy">
                here
              </Link>
              .<br />
              <br />
            </p>
            <p>
              <strong>Access to or Deletion of Personal Information</strong>
              <br />
              You may have the right under applicable law to request information
              about the collection of your personal information by Rivergrove,
              or access to or deletion of your personal information. If you wish
              to do so, please visit{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>{" "}
              or contact{" "}
              <Link onClick={toTop} to="/contact">
                Customer Service
              </Link>
              . Depending on your choices, certain services may be limited or
              unavailable.
              <br />
              <br />
            </p>
            <p>
              <strong>Unsubscribing</strong>
              <br />
              If you’d like to opt-out of marketing and other non-transactional
              communications from Rivergrove, click the Unsubscribe link at the
              bottom of an email you've received from Rivergrove. You will not
              be able to opt out of important or transactional communications
              from us, for example, billing confirmations and reminders, device
              updates, security-related communications, and service
              announcements. See our
              <Link onClick={toTop} to="/privacy">
                Privacy Notice
              </Link>{" "}
              for more information.
              <br />
              <br />
            </p>
            <p>
              <strong>Cookie Policy</strong>
              <br />
              View our cookie policy by clicking{" "}
              <Link onClick={toTop} to="/terms">
                here
              </Link>
              .
              <br />
              <br />
            </p>
            <p>
              If you have any questions or concerns, please email us at{" "}
              <Link onClick={toTop} to="mailto:depot@rivergrove.blog">
                depot@rivergrove.blog
              </Link>
            </p>
          </span>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Privacy;
